<template>
  <div class="card-item">
    <div @click="open = setOpen()" class="card-item-data">
      <div><span class="card-item-title" v-html="displayData(columnMeta.items[0], item[columnMeta.items[0].fieldId], item)"></span> <span v-html="displayData(columnMeta.items[1], item[columnMeta.items[1].fieldId], item)"></span></div>
      <div v-if="columnMeta.items.length >= 3">{{ columnMeta.items[2].label }}: {{ displayData(columnMeta.items[2], item[columnMeta.items[2].fieldId], item) }}</div>
      <div v-if="columnMeta.items.length >= 4">{{ columnMeta.items[3].label }}: {{ displayData(columnMeta.items[3], item[columnMeta.items[3].fieldId], item) }}</div>
      <VueSlideToggle :open="open" tag="section" :duration="500" v-if="columnMeta.items.length >= 4">

        <!-- class="table is-narrow" -->
        <!-- class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" -->

        <table class="card-table is-full-width">
          <tr v-for="column in columnMeta.items.slice(4)" :key="column.fieldId">
            <td>{{ column.label }}</td>
            <div v-if="column.dataType === 'callback'" v-html="column.callback(item)" />
            <td v-else-if="Array.isArray(item[column.fieldId])">{{ arrayOutput(item[column.fieldId]) }}</td>
            <td v-else>{{ displayData(column, item[column.fieldId], item) }}</td>
            <td style="text-align: right">
              <template v-if="column.actionType === 'fieldAction'">
                <button class="button is-small" @click="fieldAction(column.action, item, $event)"><i class="fal fa-arrow-square-right"></i></button>
              </template>
            </td>
          </tr>
        </table>

        <!--
        <div v-for="column in columnMeta.items.slice(3)" :key="column.fieldId" class="card-item-field">
          <span>{{ column.label }}: </span>
          <span v-if="Array.isArray(item[column.fieldId])">{{ arrayOutput(item[column.fieldId]) }}</span>
          <span v-else>{{ displayData(column, item[column.fieldId]) }}</span>
        </div>
        -->

      </VueSlideToggle>

    </div>

    <div class="card-item-action-buttons" v-if="showContextMenu || (actionMeta && actionMeta.type === 'buttons')">

      <template v-if="actionMeta && actionMeta.type === 'buttons'">
        <template v-for="action in actionMeta.items">
          <template v-if="typeof(action.showCondition) !== 'function' || action.showCondition(item)">
            <button
              class="button mini-button"
              :key="action.action"
              :disabled="typeof (action.disableCondition) === 'function' && action.disableCondition(item)"
              @click="rowAction(action.action, item, $event)">
              <span class="icon" v-if="action.iconClass">
                <i :class="action.iconClass"></i>
              </span>
              <!-- <span v-if="action.label">{{ action.label }}</span>-->
            </button>
          </template>
        </template>
      </template>

      <context-menu :item="item" v-if="showContextMenu" class="mini-button"></context-menu>

    </div>

  </div>
</template>

<script>

import { VueSlideToggle } from 'vue-slide-toggle'
import ContextMenu from '@/components/nav/ContextMenu'
import { formatNumber } from '@/helpers'

export default {
  props: ['item', 'columnMeta', 'actionMeta', 'showContextMenu'],
  components: {
    VueSlideToggle,
    ContextMenu
  },

  data () {
    return {
      open: false,
      disableExpansion: false
    }
  },

  methods: {
    joinArray (column, array) {
      let subItems = JSON.parse(JSON.stringify(array))
      let overflow = false

      if (subItems.length > 3) {
        subItems = subItems.splice(0, 3)
        overflow = true
      }

      let ret = subItems.map(x => x[column.displayProperty]).join(', ')

      if (overflow) {
        ret += '…'
      }

      return ret
    },

    displayData (column, value, item) {
      let ret = ''

      if (column.dataType === 'callback') {
        return column.callback(item)
      }

      // if (column.dataType === 'success-warning-error') {
      //   if (value) {
      //     return '<i class="fal fa-check success-warning-error-icon success"></i>'
      //   }
      //   else {
      //     return '<i class="fal fa-exclamation success-warning-error-icon error"></i>'
      //   }
      // }

      if (Array.isArray(value)) {
        if (value.length === 0) {
          ret = '(inga)'
        } else {
          ret = this.joinArray(column, value)
        }
      }

      switch (column.dataType) {
        case 'date':
          if (!value) {
            ret = ''
          }
          ret = this.$options.filters.date(value)
          break

        case 'dateTime':
          if (!value) {
            ret = ''
          }
          ret = this.$options.filters.dateTime(value)
          break

        case 'translate':
          const translation = column.translations.filter(x => x.key === value)
          if (translation && translation[0] && translation[0].value) {
            ret = translation[0].value
          } else {
            ret = value
          }
          break

        case 'number':
          ret = formatNumber(value)
          break

        case 'currency':
          ret = formatNumber(value) + ' kr'
          break

        case 'days':
          if (parseInt(value) > 1) {
            ret = value + ' dagar'
          } else {
            ret = value + ' dag'
          }
          break

        case 'callback':
          column.callback(column)
          break

        default:
          ret = value
          break
      }

      if (column.suffix) {
        ret += ' ' + column.suffix
      }

      return ret
    },

    setOpen () {
      if (this.disableExpansion) {
        return this.open
      }

      return !this.open
    },

    fieldAction (action, item, e) {
      this.disableExpansion = true
      this.$emit('fieldAction', action, item)
      event.preventDefault()

      setTimeout(() => {
        this.disableExpansion = false
      }, 100)
    },

    rowAction (action, item, event) {
      this.disableExpansion = true
      this.$emit('rowAction', action, item)
      event.preventDefault()

      setTimeout(() => {
        this.disableExpansion = false
      }, 100)
    },

    arrayOutput (array) {
      if (array.length === 0) {
        return '(inga)'
      }
      return array.join(', ')
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/common/common';
  .card-item {
    border: 1px solid #ccc;
    background-color: #fcfcfd;
    border-radius: 4px;
    padding:5px;
    margin: 5px;
    display: flex;;
    flex-wrap: wrap;

    .card-item-title {
      font-weight: 700;
    }

    .card-item-context-menu {
      margin-left: 10px;
    }

    .card-item-data {
      flex: 1 0;
      word-break: break-all;

      @include mobile {
        flex: 1 0 100%;
      }

      .card-item-title, .card-item-field {
        word-break: break-all;
      }
    }

    .card-item-action-buttons {
      text-align: right;
      flex: 1 0 6rem;
    }
  }
  table.card-table {
    margin-top:20px;
    td {
      padding: 0.3em 0.3em;
    }
  }
  .mini-button {
    display: inline-block;
    padding: 0;
    line-height: 1rem;
    font-size: 0.75rem !important;
    width: 2rem;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/CardItem.vue